var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fade
    ? _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            class: _vm.classes,
            style: _vm.wraperStyles,
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.check.apply(null, arguments)
              }
            }
          },
          [
            _vm.showDot
              ? _c("span", { class: _vm.dotClasses, style: _vm.bgColorStyle })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              { class: _vm.textClasses, style: _vm.textColorStyle },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _vm.closable
              ? _c("Icon", {
                  class: _vm.iconClass,
                  attrs: { color: _vm.lineColor, type: "ios-close" },
                  nativeOn: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    : _c(
        "div",
        {
          class: _vm.classes,
          style: _vm.wraperStyles,
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.check.apply(null, arguments)
            }
          }
        },
        [
          _vm.showDot
            ? _c("span", { class: _vm.dotClasses, style: _vm.bgColorStyle })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            { class: _vm.textClasses, style: _vm.textColorStyle },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.closable
            ? _c("Icon", {
                class: _vm.iconClass,
                attrs: { color: _vm.lineColor, type: "ios-close" },
                nativeOn: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.close.apply(null, arguments)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-188d6c7b", { render: render, staticRenderFns: staticRenderFns })
  }
}